/* ClearBloom theme behaviour: cart drawer (Shopify Ajax Cart API), routine builder, gallery, sticky bar */
(function () {
  'use strict';
  var CB = window.CB || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var fmt;
  try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: CB.currency || 'USD' }); } catch (e) { fmt = null; }
  var money = function (cents) { var v = (cents || 0) / 100; return fmt ? fmt.format(v) : '$' + v.toFixed(2); };

  /* ---------- Cart ---------- */
  var drawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function openCart() {
    if (!drawer) { window.location.href = CB.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.cb-drawer__head [data-cart-close]', drawer);
    if (closeBtn) closeBtn.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function routineInfo(cart) {
    var ids = (CB.routineIds || []).filter(Boolean);
    if (ids.length !== 3) return { sets: 0, disc: 0 };
    var qty = {}, unit = {};
    cart.items.forEach(function (it) {
      if (ids.indexOf(it.product_id) === -1) return;
      qty[it.product_id] = (qty[it.product_id] || 0) + it.quantity;
      unit[it.product_id] = Math.max(unit[it.product_id] || 0, it.final_price);
    });
    var sets = Math.min.apply(null, ids.map(function (id) { return qty[id] || 0; }));
    var setPrice = ids.reduce(function (a, id) { return a + (unit[id] || 0); }, 0);
    return { sets: sets, disc: Math.round(sets * setPrice * (CB.routinePercent || 0) / 100) };
  }

  function checkoutUrl(info) {
    return info.sets > 0 && CB.routineCode ? '/checkout?discount=' + encodeURIComponent(CB.routineCode) : '/checkout';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      if (String(el.textContent) !== String(cart.item_count)) {
        el.textContent = cart.item_count;
        el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      }
    });
    var info = routineInfo(cart);
    $$('[data-checkout]').forEach(function (a) { a.setAttribute('href', checkoutUrl(info)); });
    if (!drawer) return;

    var lines = $('[data-cart-lines]', drawer);
    lines.innerHTML = '';
    if (!cart.items.length) {
      var empty = document.createElement('div');
      empty.className = 'cb-drawer__empty';
      empty.innerHTML = '<span>Your cart is empty.</span>';
      var keep = document.createElement('button');
      keep.type = 'button'; keep.className = 'cb-btn cb-btn--outline cb-press'; keep.textContent = 'Keep shopping';
      keep.addEventListener('click', closeCart);
      empty.appendChild(keep);
      lines.appendChild(empty);
    }
    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'cb-dline';
      var img = document.createElement('img');
      img.alt = ''; img.width = 72; img.height = 72;
      if (it.image) img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var info = document.createElement('div'); info.className = 'cb-dline__info';
      var top = document.createElement('div'); top.className = 'cb-dline__top';
      var name = document.createElement('a'); name.href = it.url; name.textContent = it.product_title;
      var price = document.createElement('span'); price.textContent = money(it.final_line_price);
      top.appendChild(name); top.appendChild(price);
      info.appendChild(top);
      if (it.variant_title && it.variant_title !== 'Default Title') {
        var vt = document.createElement('span'); vt.className = 'cb-muted cb-small'; vt.textContent = it.variant_title; info.appendChild(vt);
      }
      var bottom = document.createElement('div'); bottom.className = 'cb-dline__bottom';
      var q = document.createElement('div'); q.className = 'cb-dqty';
      var dec = document.createElement('button'); dec.type = 'button'; dec.textContent = '−'; dec.setAttribute('aria-label', 'Decrease quantity of ' + it.product_title);
      var n = document.createElement('span'); n.textContent = it.quantity;
      var inc = document.createElement('button'); inc.type = 'button'; inc.textContent = '+'; inc.setAttribute('aria-label', 'Increase quantity of ' + it.product_title);
      dec.addEventListener('click', function () { change(it.key, it.quantity - 1, row); });
      inc.addEventListener('click', function () { change(it.key, it.quantity + 1, row); });
      q.appendChild(dec); q.appendChild(n); q.appendChild(inc);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'cb-remove'; rm.textContent = 'Remove';
      rm.addEventListener('click', function () { change(it.key, 0, row); });
      bottom.appendChild(q); bottom.appendChild(rm);
      info.appendChild(bottom);
      row.appendChild(img); row.appendChild(info);
      lines.appendChild(row);
    });

    var total = cart.total_price - info.disc;
    $('[data-cart-sub]', drawer).textContent = money(cart.total_price);
    $('[data-cart-disc]', drawer).textContent = '−' + money(info.disc);
    $('[data-cart-disc-row]', drawer).hidden = info.disc <= 0;
    $('[data-cart-total]', drawer).textContent = money(total);

    var thr = CB.freeShipping || 0;
    var msg = $('[data-ship-msg]', drawer), bar = $('[data-ship-bar]', drawer);
    if (thr > 0) {
      var left = thr - total;
      msg.textContent = cart.item_count === 0 ? 'Free shipping on orders over ' + money(thr)
        : (left > 0 ? "You're " + money(left) + ' away from free shipping' : "You've unlocked free shipping");
      bar.style.width = Math.min(100, Math.max(0, (total / thr) * 100)) + '%';
    }
  }

  function fetchCart() {
    return fetch(CB.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function notice(text) {
    if (!drawer) { window.alert(text); return; }
    var lines = $('[data-cart-lines]', drawer);
    var p = document.createElement('p');
    p.className = 'cb-error'; p.setAttribute('role', 'alert'); p.textContent = text;
    lines.insertBefore(p, lines.firstChild);
  }

  function add(items, btn) {
    if (!items.length) return Promise.resolve();
    if (btn) btn.classList.add('is-busy');
    return fetch(CB.routes.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        return fetchCart().then(function () {
          openCart();
          if (!res.ok) notice(res.body.description || res.body.message || 'Sorry, that item could not be added.');
        });
      })
      .catch(function () { notice('Something went wrong. Please try again.'); openCart(); })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  }

  function change(key, quantity, row) {
    if (row) row.classList.add('is-busy');
    return fetch(CB.routes.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items) renderCart(cart); else fetchCart(); })
      .catch(fetchCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t) return;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }
    var addBtn = t.closest('[data-add]');
    if (addBtn) { e.preventDefault(); add([{ id: Number(addBtn.getAttribute('data-add')), quantity: 1 }], addBtn); return; }
    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var gal = thumb.closest('.cb-gallery');
      var main = gal && $('[data-gallery-main]', gal);
      if (main) {
        main.classList.add('is-fading');
        setTimeout(function () { main.src = thumb.getAttribute('data-thumb'); main.classList.remove('is-fading'); }, 150);
        $$('[data-thumb]', gal).forEach(function (b) { b.classList.toggle('is-on', b === thumb); });
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeCart();
  });

  /* ---------- Product page form ---------- */
  var pdpForm = document.getElementById('cb-pdp-form');
  if (pdpForm) {
    var sel = $('[data-pdp-variant]', pdpForm);
    var priceEl = $('[data-pdp-price]');
    if (sel && priceEl) sel.addEventListener('change', function () { priceEl.textContent = sel.selectedOptions[0].getAttribute('data-price'); });
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = Number(new FormData(pdpForm).get('id'));
      add([{ id: id, quantity: 1 }], $('[type="submit"]', pdpForm));
    });
  }

  /* ---------- Routine builder ---------- */
  var builder = $('[data-builder]');
  if (builder) {
    var pct = Number(builder.getAttribute('data-percent')) || 0;
    var rows = $$('[data-step]', builder);
    var qty = 1;
    var update = function () {
      var on = rows.filter(function (r) { return r.classList.contains('is-on') && !r.hasAttribute('data-soldout'); });
      var full = on.length === rows.length && rows.length === 3;
      var sub = on.reduce(function (a, r) { return a + Number(r.getAttribute('data-price')); }, 0) * qty;
      var total = full ? Math.round(sub * (100 - pct) / 100) : sub;
      $('[data-r-total]', builder).textContent = money(total);
      $('[data-r-sub]', builder).textContent = money(sub);
      var note = $('[data-r-note]', builder);
      note.textContent = full ? 'Full routine · ' + pct + '% off at checkout' : 'Add all 3 steps to save ' + pct + '%';
      note.classList.toggle('is-full', full);
      $$('[data-full-only]').forEach(function (el) { el.hidden = !full; });
      $('[data-qty-val]', builder).textContent = qty;
      var label = on.length === 0 ? 'Pick at least one step'
        : (full ? 'Add routine' : 'Add ' + on.length + ' item' + (on.length > 1 ? 's' : '')) + ' — ' + money(total);
      $$('[data-add-routine]', builder).forEach(function (b) { b.textContent = label; b.disabled = on.length === 0; });
      var st = $('[data-sticky-title]'), sn = $('[data-sticky-note]');
      if (st) st.textContent = full ? 'The 3-Step Routine' : on.length + ' of 3 steps selected';
      if (sn) sn.textContent = money(total) + (full ? ' · ' + pct + '% off' : ' · add all 3 to save ' + pct + '%');
    };
    rows.forEach(function (r) {
      r.addEventListener('click', function () {
        r.classList.toggle('is-on');
        r.setAttribute('aria-pressed', r.classList.contains('is-on') ? 'true' : 'false');
        update();
      });
    });
    $$('[data-size]', builder).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-size]', builder).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var row = rows[0];
        row.setAttribute('data-variant', b.getAttribute('data-size'));
        row.setAttribute('data-price', b.getAttribute('data-price'));
        $('[data-step-price]', row).textContent = money(Number(b.getAttribute('data-price')));
        $('[data-step-size]', row).textContent = b.getAttribute('data-label');
        update();
      });
    });
    $$('[data-qty]', builder).forEach(function (b) {
      b.addEventListener('click', function () { qty = Math.max(1, qty + Number(b.getAttribute('data-qty'))); update(); });
    });
    $$('[data-add-routine]').forEach(function (b) {
      b.addEventListener('click', function () {
        var items = rows.filter(function (r) { return r.classList.contains('is-on') && !r.hasAttribute('data-soldout'); })
          .map(function (r) { return { id: Number(r.getAttribute('data-variant')), quantity: qty }; });
        add(items, b);
      });
    });
    update();

    /* Mobile sticky bar: show once the buy button has scrolled out of view */
    var sticky = $('[data-sticky]');
    var buy = $('.cb-buy', builder);
    if (sticky && buy && 'IntersectionObserver' in window) {
      var buyVisible = false;
      new IntersectionObserver(function (entries) { buyVisible = entries[0].isIntersecting; toggleSticky(); }).observe(buy);
      var toggleSticky = function () { sticky.classList.toggle('is-shown', window.scrollY > 500 && !buyVisible); };
      window.addEventListener('scroll', toggleSticky, { passive: true });
    }
  }

  fetchCart().catch(function () {});
})();
